/** MSAL authority hostnames used in sessionStorage cache keys. */
const MSAL_AUTHORITY_HOSTS = ['login.windows.net', 'login.microsoftonline.com'] as const;

/** Whether a sessionStorage key belongs to MSAL / Azure AD auth cache. */
export function isMsalSessionKey(key: string): boolean {
  if (key.startsWith('msal.')) {
    return true;
  }
  const lower = key.toLowerCase();
  return MSAL_AUTHORITY_HOSTS.some((host) => {
    const idx = lower.indexOf(host);
    if (idx <= 0) {
      return false;
    }
    const before = lower[idx - 1];
    const after = lower[idx + host.length];
    return (before === '.' || before === '/') && (after === undefined || after === '.' || after === '/');
  });
}

/** Remove all MSAL-related entries from sessionStorage. */
export function clearMsalSessionStorage(): void {
  const keysToRemove: string[] = [];
  for (let i = 0; i < sessionStorage.length; i++) {
    const key = sessionStorage.key(i);
    if (key && isMsalSessionKey(key)) {
      keysToRemove.push(key);
    }
  }
  keysToRemove.forEach((key) => sessionStorage.removeItem(key));
}
